export enum CompanySize {
  '1-20' = '1-20',
  '21-50' = '21-50',
  '51-100' = '51-100',
  '101-150' = '101-150',
  '151-250' = '151-250',
  '251-500' = '251-500',
  '501-1000' = '501-1000',
  '1000+' = '1000+',
}

export enum PricingCompanySizeE {
  '1-20' = '1-20',
  '21-50' = '21-50',
  '51-100' = '51-100',
  '101-150' = '101-150',
  '151-250' = '151-250',
  '251-500' = '251-500',
  '501+' = '501',
}

export type PricingCompanySize = PricingCompanySizeE | string;
